import Button from "@mui/material/Button";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import Input from "../shared/Input/Input";
import * as Yup from "yup";
import {
  useLazyUserResendCodeQuery,
  useLazyValidateForgotPasswordOtpQuery,
  useLazyValidateLoginOtpQuery,
} from "../../services/rtkQueryServices/authenticationService";
import { routePaths } from "../../constants/routePaths";
// import { validationMessages } from "../../constants/forms/validationMessages";
import { LOGIN_LITERALS } from "../../constants/literals";
import { dataStore } from "../../constants/dataStore";
import { errorMessages } from "../../constants/errorMessages";
import { useAuth } from "../../context/AuthProvider";

export default function OtpValidation() {
  const navigate = useNavigate();
  const auth = useAuth();
  const otpReSendTime = 30;
  const [resendOtpRequest] = useLazyUserResendCodeQuery();
  const [validateLoginCode] = useLazyValidateLoginOtpQuery();
  const [validateForgotPasswordCode] = useLazyValidateForgotPasswordOtpQuery();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [resendOtpTimer, setResendOtpTimer] = useState<any>(otpReSendTime);
  const location = useLocation();
  const validationType = location.state;
  const loginDetails = useSelector((state: any) => state.email.value);
  const initialFormValue = useMemo(() => {
    if (!loginDetails) navigate(routePaths.login);
    return {
      code: "",
      userEmail: loginDetails?.email,
      expiryTime: addHours(new Date(), 1),
    };
  }, [loginDetails, navigate]);

  useEffect(() => {
    if (!loginDetails) {
      navigate(routePaths.login);
    }
  }, []);
  function addHours(date: Date, hours: number) {
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    return date;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (resendOtpTimer > 0) {
        setResendOtpTimer(resendOtpTimer - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [resendOtpTimer]);

  const resendOtp = () => {
    setResendOtpTimer(otpReSendTime);
    resendOtpRequest({})
      .then((res: any) => {})
      .catch((e: any) => {
        setErrorMessage(LOGIN_LITERALS.somethingWentWrong);
      });
  };
  const validationSchema = () =>
    Yup.object({
      code: Yup.string()
        .required(errorMessages.required("Verification code"))
        .min(6, errorMessages.length("Verification code", 6))
        .max(6, errorMessages.length("Verification code", 6)),
    });

  const handleChange = () => {
    setErrorMessage("");
  };
  const validateLoginOtp = (values: any) => {
    validateLoginCode(values)
      .then((res: any) => {
        if (res?.data?.isSuccess) {
          auth?.logIn();
          localStorage.removeItem(dataStore.login_code);
          setErrorMessage("");
        } else {
          setErrorMessage((res.error as any).data.message);
        }
      })
      .catch((e) => {
        setErrorMessage(LOGIN_LITERALS.somethingWentWrong);
      });
  };
  const validateForgotPasswordOtp = (values: any) => {
    validateForgotPasswordCode(values)
      .then((res: any) => {
        if (res?.data?.isSuccess) {
          localStorage.removeItem(dataStore.login_code);
          navigate(routePaths.setPassword);
          setErrorMessage("");
        } else {
          setErrorMessage((res.error as any).data.message);
        }
      })
      .catch((e) => {
        setErrorMessage(LOGIN_LITERALS.somethingWentWrong);
      });
  };
  return (
    <Formik
      initialValues={initialFormValue}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {
        if (validationType.isloginValidation) {
          validateLoginOtp(values);
        } else {
          validateForgotPasswordOtp(values);
        }
      }}
    >
      {(formik) => (
        <Form
          onChange={handleChange}
          onSubmit={formik.handleSubmit}
          className="login-form-container"
        >
          <div className="login-form">
            <div className="login-header mb-4">Enter the verification code</div>
            <div className="login-mail mb-2">
              {validationType.isloginValidation ? (
                <>
                  {`A verification code has been sent to "${loginDetails}".`}
                  <div>
                    Please enter it below and click Validate. This code is valid
                    for 15 minutes.
                  </div>
                </>
              ) : (
                <>
                  If we find your account, a verification code will be sent to{" "}
                  {loginDetails}, which is valid for 15 minutes.
                </>
              )}
            </div>
            <Input
              label="Verification Code"
              name="code"
              placeholder={LOGIN_LITERALS.enterCode}
              // onKeyDown={Utility.allowOnlyNumerics}
              maxLength={6}
              errorMsg={
                formik.touched.code &&
                formik.errors.code &&
                (formik.errors as any).code
              }
              required
              value={formik.values.code}
              onInput={(e) => {
                formik.handleChange(e);
                setErrorMessage("");
              }}
            />
          </div>

          {errorMessage && (
            <span className="error-message">{errorMessage}</span>
          )}
          <div className="login-actions">
            <Button
              className={
                !formik.errors.code ? "form-button" : "form-button disabled"
              }
              type="submit"
              disabled={!formik.isValid || !formik.dirty}
            >
              {LOGIN_LITERALS.validate}
            </Button>
          </div>
          <div className="d-flex flex-wrap justify-content-center pt-4 mb-2">
            <Button
              variant="text"
              className="resend-otp"
              type="button"
              onClick={() => {
                formik.resetForm();
                resendOtp();
                setErrorMessage("");
              }}
              disabled={resendOtpTimer > 0}
            >
              <div className="disable-otp">
                {resendOtpTimer > 0 ? (
                  `Resend Code in 00:${resendOtpTimer.toLocaleString("en-us", {
                    minimumIntegerDigits: 2,
                  })}`
                ) : (
                  <span>{LOGIN_LITERALS.resendOtp}</span>
                )}
              </div>
              <div>{/* <TimelineLogo className="ms-2" /> */}</div>
            </Button>
          </div>
          {/* <div className="mt-3 p-4 otp-info-text">{LOGIN_LITERALS.otpInfo}</div> */}
        </Form>
      )}
    </Formik>
  );
}
